import FbButton from 'components/FbUI/FbButton'
import { HiOutlineCheckCircle } from 'react-icons/hi'

function Verified() {
  return (
    <div className="w-96 flex-shrink-0">
      <div className="text-2xl font-light text-fg-secondary">
        Welcome to <span className="text-brand font-semibold">First Bite</span>
      </div>

      <div className="mt-8 flex flex-col items-center text-center">
        <div className="w-16 h-16 rounded-full bg-surface-hover flex items-center justify-center mb-4">
          <HiOutlineCheckCircle className="w-10 h-10 text-brand" />
        </div>

        <h1 className="text-xl font-semibold mb-2">Email verified</h1>

        <p className="text-gray-600 mb-6">
          Your email has been successfully verified. You can now log in to your
          account.
        </p>

        <FbButton
          onClick={() => (window.location.href = '/login')}
          className="w-full"
        >
          Go to Login
        </FbButton>
      </div>
    </div>
  )
}

export default Verified
